import { render, staticRenderFns } from "./EventDetailsModal.vue?vue&type=template&id=79638947"
import script from "./EventDetailsModal.vue?vue&type=script&lang=js"
export * from "./EventDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./EventDetailsModal.vue?vue&type=style&index=0&id=79638947&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports